export const costFormatter = (cost) => {
    const reverseCost = reverseString(cost.toString());

    let reverseFormattedCost = '';

    for (let i = 1; i <= reverseCost.length; i++) {
        reverseFormattedCost += reverseCost[i-1];
        if(i%3 === 0) {
            reverseFormattedCost += ' ';
        }
    }


    const formattedCost= reverseString(reverseFormattedCost);
    return formattedCost;
};



function reverseString(str) {
    let newString = '';

    for (let i = str.length - 1; i >= 0; i--) {
        newString += str[i];
    }

    return newString;
}



// WEBPACK FOOTER //
// ./src/costFormatter/costFormatter.js